// Regla de "momento pasado", compartida por las dos capas.
//
// El schema `fechaPasada` de shared/schemas/comunes.js rechaza en el backend
// cualquier instante futuro con un margen de 5 minutos por relojes desfasados.
// Esta funcion aplica exactamente el mismo criterio en el formulario, para que
// el usuario vea el aviso en su campo y no un 400 al final del wizard.
//
// Si cambia el margen, cambia en los dos lados.

export const MARGEN_RELOJ_MS = 5 * 60 * 1000;

/** ¿La fecha (YYYY-MM-DD) y hora (HH:MM) locales ya ocurrieron? */
export function esMomentoPasado(fecha, hora) {
  if (!fecha) return false;
  const momento = new Date(`${fecha}T${hora || "00:00"}`);
  if (Number.isNaN(momento.getTime())) return false;
  return momento.getTime() <= Date.now() + MARGEN_RELOJ_MS;
}

/** Fecha de hoy en YYYY-MM-DD local, para el `max` de un <input type="date">. */
export function hoyLocal() {
  return new Date().toLocaleDateString("en-CA");
}

/** Hora actual en HH:MM local, para el valor inicial de un <input type="time">. */
export function ahoraLocal() {
  return new Date().toLocaleTimeString("es-CO", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
